// Canonical public origin is separate from the API/preview origin.
if (!process.env.REACT_APP_SITE_URL) {
  throw new Error("REACT_APP_SITE_URL is required");
}
export const SITE_URL = new URL(process.env.REACT_APP_SITE_URL).origin;